import { CreateCloudAccountAzure } from '@/components/configuration/azure/create-subscription'
import { createFileRoute } from '@tanstack/react-router'
import { store } from '@/state/breadcrumb-store'
import { CreateAWSAccountForm } from '@/components/configuration/aws/create-account'

export const Route = createFileRoute(
  '/customer/$customerId/configuration/$configurationId/create/$configType',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { customerId, configurationId, configType } = Route.useParams()
  store.trigger.changePath({
    newPath:
      [{ params: {}, to: "/customer", label: "Customer" },
      { params: { customerId: customerId }, to: "/customer/$customerId", label: customerId },
      { params: { customerId: customerId }, to: "/customer/$customerId", label: "Configuration" },
      { params: { configurationId, customerId }, to: "/customer/$customerId/configuration/$configurationId", label: configurationId },
      { params: { configurationId, customerId, configType }, to: "/customer/$customerId/configuration/$configurationId/create/$configType", label: "create" },
      ]
  })
  if (configType == "azure") {
    return <CreateCloudAccountAzure configurationId={configurationId} customerId={customerId}></CreateCloudAccountAzure>
  } else if (configType == 'aws') {
    return <CreateAWSAccountForm customerId={customerId} configurationId={configurationId}></CreateAWSAccountForm>
  }

  return <></>
} 
